import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { FaChevronDown } from "react-icons/fa";

const ExportButton = ({ menuOptions = [] }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const wrapperRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuItemClick = (onClick) => {
    setOpenMenu(false);
    if (onClick) onClick();
  };

  return (
    <Container ref={wrapperRef}>
      <ExportSelectButton onClick={() => setOpenMenu((p) => !p)}>
        Export Options
        <Chevron isOpen={openMenu}>
          <FaChevronDown />
        </Chevron>
      </ExportSelectButton>

      {openMenu && (
        <Dropdown>
          {menuOptions.map((item, index) => (
            <DropdownItem
              key={index}
              onClick={() => handleMenuItemClick(item.onClick)}
            >
              {item.label}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </Container>
  );
};

export default ExportButton;

const Container = styled.div`
  position: relative;
  width: 172px;
`;

const ExportSelectButton = styled.button`
  width: 100%;
  height: 29px;
  padding: 0 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #faf8f8;
  border: 1px solid #106271;
  border-radius: 8px;

  font-family: "Space Grotesk";
  font-size: 14px;
  color: #106271;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

const Chevron = styled.span`
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});

  svg {
    width: 16px;
    height: 16px;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 100;
  overflow: hidden;
`;

const DropdownItem = styled.div`
  padding: 10px 12px;
  font-family: "Space Grotesk";
  font-size: 13px;
  color: #106271;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f3f9fa;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f3f4f6;
  }
`;
